<div *ngIf="countries?.length > 0; else loading" class="col-md-11 col-xs-12 mt-3 me-4 ms-4">
  <div class="buttontop btntop col-lg-11">
    <table>
      <tr>
        <td style="margin-left:10px;">
          <button type="submit" class="btn border" [disabled]="!memberform?.valid || saveBtnDisabled" (click)="saveForm()">Spara</button>
        </td>
        <td style="margin-left:10px;">
          <button type="submit" (click)="cancel()" class="btn border">Avbryt</button>
        </td>
    </table>
  </div>
 
  <div id="contentToConvert" class="col-xs-12 col-xl-12">
    <form [formGroup]="memberform" autocomplete="off" *ngIf="memberform.get('institutionId').value">
      <div *ngIf="institution"><b>Skapa ny medlem i Orden</b> [{{institution.shortName}} {{institution.name}}]</div><br>
      <div class="row">
        <div *ngIf="!institution" class="col-sm-2" style="min-width: 100px;max-width: 100px;display: none;">
          <label>
            Institutionsid
          </label>
          <input id="institutionId" type="text" class="form-control form-control-sm" formControlName="institutionId" readonly>
        </div>
        <div class="col-md-4">
          <label>Invigningsdatum</label>
          <app-calendar [form]="memberform" formName="initiatedDate" [required]=true (change)="test($event)"></app-calendar>
        </div>
      </div>
      <div class="row" style="margin-top:10px;">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
          <div formGroupName="member">
            <div style="min-width:150px;">
              <mat-expansion-panel [expanded]="true" class="accordionmargin">
                <mat-expansion-panel-header [expandedHeight]="'48px'">
                  <mat-panel-title>
                    Medlem
                  </mat-panel-title>
                  <mat-panel-description>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="form-group">
                  <label for="givenName">
                    Förnamn
                  </label>
                  <input type="text" class="form-control form-control-sm" id="givenName" formControlName="givenName" [value]="givenName?.value | capitalize" required>
                  <span *ngIf="(givenName?.dirty || givenName?.touched) && givenName?.invalid && givenName?.errors.required">
                    Förnamn är obligatoriskt.
                  </span>
                </div>
                <div class="form-group">
                  <label for="otherForeNames">
                    Övriga Förnamn
                  </label>
                  <input type="text" class="form-control form-control-sm" id="otherForeNames" formControlName="otherForeNames" [value]="oterForeNames?.value | capitalize">
                </div>
                <div class="form-group">
                  <label for="middleName">
                    Mellannamn
                  </label>
                  <input type="text" class="form-control form-control-sm" id="middleName" formControlName="middleName" [value]="middleName?.value | capitalize">
                </div>
                <div class="form-group">
                  <label for="familyName">
                    Efternamn
                  </label>
                  <input type="text" class="form-control form-control-sm" id="familyName" formControlName="familyName" [value]="familyName?.value | capitalize" required>
                  <span *ngIf="(familyName?.dirty || familyName?.touched) && familyName?.invalid && familyName?.errors.required">
                    Efternamn är obligatoriskt.
                  </span>
                </div>
                <div class="form-group">
                  <label for="formerName">
                    Tidigare efternamn
                  </label>
                  <input type="text" class="form-control form-control-sm" id="formerName" formControlName="formerName" [value]="formerName?.value | capitalize">
                </div>
                <div class="form-group">
                  <label for="title">
                    Yrke/Titel
                  </label>
                  <input type="text" class="form-control form-control-sm" id="title" formControlName="title" [value]="title?.value">
                </div>
                <div class="form-group" style="width: 120px;">
                  <label for="birthday">
                    Födelsedatum
                  </label>
                  <input type="text" class="form-control form-control-sm" id="birthday" (change)="servicedbirthday=birthday?.value" mask="0000-00-00" formControlName="birthday" title="Enter a date in this format YYYY-MM-DD" [value]=servicedbirthday
                    required />
                </div>
                <div class="form-group" style="width:220px;">
                  <label for="localId">
                    Lokalt medlemsnummer
                  </label>
                  <input type="text" class="form-control form-control-sm" id="localId" formControlName="localId" [value]="localId?.value">
                </div>
                <div class="form-group" style="border:none;">
                  <label for="isSubscriber" class="form-check-label">
                    <mat-checkbox class="form-control" id="isSubscriber" formControlName="isSubscriber">SOFT-prenumeration
                    </mat-checkbox>
                  </label>
                </div>
              </mat-expansion-panel>
            </div>
            <mat-expansion-panel class="accordionmargin">
              <mat-expansion-panel-header [expandedHeight]="'48px'">
                <mat-panel-title>
                  Telefonnummer
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="form-row">
                <div class="form-group col-sm-6">
                  <label for="phone">
                    Telefon 1
                  </label>
                  <input type="text" class="form-control form-control-sm" id="phone" formControlName="phone">
                </div>
                <div class="form-group col-sm-6">
                  <label for="phone2">
                    Telefon 2
                  </label>
                  <input type="text" class="form-control form-control-sm" id="phone2" formControlName="phone2">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-sm-6">
                  <label for="phoneWork">
                    Arbetstelefon
                  </label>
                  <input type="text" class="form-control form-control-sm" id="phoneWork" formControlName="phoneWork">
                </div>
                <div class="form-group col-sm-6">
                  <label for="phoneMobile">
                    Mobiltelefon
                  </label>
                  <input type="text" class="form-control form-control-sm" id="phone" formControlName="phoneMobile">
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="accordionmargin">
              <mat-expansion-panel-header [expandedHeight]="'48px'">
                <mat-panel-title>
                  E-post och Hemsida
                </mat-panel-title>
               
              </mat-expansion-panel-header>
              <div class="form-group">
                <label for="email">
                  E-post 1
                </label>
                <input type="text" class="form-control form-control-sm" id="email" formControlName="email">
              </div>
              <div>
                <label for="email2">
                  E-post 2
                </label>
                <input type="text" class="form-control form-control-sm" id="email2" formControlName="email2">
              </div>
              <div class="form-group">
                <label for="webSite">
                  Hemsida
                </label>
                <input type="text" class="form-control form-control-sm" id="webSite" formControlName="webSite">
              </div>
            </mat-expansion-panel>
          </div>
        </div>
        <div class="col-xs-12 col-sm-8 col-md-6 col-lg-4 col-xl-3">
          <div>
            <div formGroupName="member">
              <div formGroupName="homeAddress">
                <mat-expansion-panel [expanded]=true>
                  <mat-expansion-panel-header [expandedHeight]="'48px'">
                    <mat-panel-title>
                      Hemadress
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div class="form-group">
                    <label for="homeAddress_careOf">
                      C/O
                    </label>
                    <input type="text" class="form-control form-control-sm" id="homeAddress_careOf" formControlName="careOf">
                  </div>
                  <div class="form-group">
                    <label for="homeAddress_street">
                      Gata/Box
                    </label>
                    <input type="text" class="form-control form-control-sm" id="homeAddress_street" formControlName="street" required>
                  </div>
                  <div *ngIf="homeAddress_country?.value==='Sverige'" class="form-group">
                    <label for="homeAddress.zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="homeAddress.zipCode" mask="000 00"  formControlName="zipCode" required>
                  </div>
                  <div *ngIf="homeAddress_country?.value!=='Sverige'" class="form-group">
                    <label for="homeaddress.zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="homeAddress.zipCode" formControlName="zipCode">
                  </div>
                  <div class="form-group">
                    <label for="homeAddress_city">
                      Ort
                    </label>
                    <input type="text" class="form-control form-control-sm" id="homeAddress_city" formControlName="city" required>
                  </div>
                  <div class="form-group">
                    <label for="country">Land</label>
                    <select class="form-control form-control-sm" id="country" formControlName="country" required>
                      <option></option>
                      <option *ngFor="let c of countries" [value]="c.name">{{c.name}}</option>
                    </select>
                    <span *ngIf="(homeAddress_country?.dirty || homeAddress_country?.touched) && homeAddress_country?.invalid && homeAddress_country?.errors.required">
                      Land är obligatoriskt.
                    </span>
                  </div>
                </mat-expansion-panel>
              </div>
              <div formGroupName="workAddress">
                <mat-expansion-panel class="accordionmargin">
                  <mat-expansion-panel-header [expandedHeight]="'48px'">
                    <mat-panel-title>
                      Arbetsadress
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div class="form-group">
                    <label for="workAddress_careOf">
                      C/O
                    </label>
                    <input type="text" class="form-control form-control-sm" id="workAddress_careOf" formControlName="careOf">
                  </div>
                  <div class="form-group">
                    <label for="workAddress_street">
                      Gata/Box
                    </label>
                    <input type="text" class="form-control form-control-sm" id="workAddress_street" formControlName="street">
                  </div>
                  <div *ngIf="workAddress_country?.value==='Sverige'" class="form-group">
                    <label for="workAddress.zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="workAddress.zipCode" mask="000 00" formControlName="zipCode">
                  </div>
                  <div *ngIf="workAddress_country?.value!=='Sverige'" class="form-group">
                    <label for="workAddress.zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="workAddress.zipCode" formControlName="zipCode">
                  </div>
                  <div class="form-group">
                    <label for="workAddress_city">
                      Ort
                    </label>
                    <input type="text" class="form-control form-control-sm" id="workAddress_city" formControlName="city">
                  </div>
                  <div class="form-group">
                    <label for="workcountry">Land</label>
                    <select class="form-control form-control-sm" id="workcountry" formControlName="country" [required]="workAddress_street?.value!=='' && workAddress_street?.value!==null">
                      <option></option>
                      <option *ngFor="let c of countries" [value]="c.name">{{c.name}}</option>
                    </select>
                  </div>
                </mat-expansion-panel>
              </div>
              <div formGroupName="otherAddress">
                <mat-expansion-panel class="accordionmargin">
                  <mat-expansion-panel-header [expandedHeight]="'48px'">
                    <mat-panel-title>
                      Annan adress
                    </mat-panel-title>
                  
                  </mat-expansion-panel-header>
                  <div class="form-group">
                    <label for="otherAddress_careOf">
                      C/O
                    </label>
                    <input type="text" class="form-control form-control-sm" id="otherAddress_careOf" formControlName="careOf">
                  </div>
                  <div class="form-group">
                    <label for="otherAddress_street">
                      Gata/Box
                    </label>
                    <input type="text" class="form-control form-control-sm" id="otherAddress.street" formControlName="street">
                  </div>
                  <div *ngIf="otherAddress_country?.value==='Sverige'" class="form-group">
                    <label for="otherAddress_zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="otherAddress_zipCode" mask="000 00" formControlName="zipCode">
                  </div>
                  <div *ngIf="otherAddress_country?.value !== 'Sverige'" class="form-group">
                    <label for="otherAddress_zipCode">
                      Postnummer
                    </label>
                    <input type="text" class="form-control form-control-sm" id="otherAddress_zipCode" formControlName="zipCode">
                  </div>
                  <div class="form-group">
                    <label for="otherAddress_city">
                      Ort
                    </label>
                    <input type="text" class="form-control form-control-sm" id="otherAddress_city" formControlName="city">
                  </div>
                  <div class="form-group">
                    <label for="othercountry">Land</label>
                    <select class="form-control form-control-sm" id="othercountry" formControlName="country" [required]="otherAddress_street?.value!=='' && otherAddress_street?.value!==null">
                      <option></option>
                      <option *ngFor="let c of countries" [value]="c.name">{{c.name}}</option>
                    </select>
                  </div>
                </mat-expansion-panel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<ng-template #loading>
  <p>Laddar...</p>
</ng-template>